import * as RNLocalize from 'react-native-localize';
import { RRule } from 'rrule';
import i18n from '../../../i18n';
const locales = RNLocalize.getLocales();
i18n.locale = locales[0].languageTag;
export const MONTHLY = 30;
export const FREQUENCY = {
    1: 'Daily',
    7: 'Weekly',
    14: i18n.t('fortnightly'),
    28: 'Every 4 weeks',
    30: 'Monthly',
    60: '2 months',
    90: 'Quarterly',
    180: '6 months',
    360: 'Yearly',
};
export const RRULE_FREQUENCY = {
    1: { freq: RRule.DAILY, interval: 1 },
    7: { freq: RRule.WEEKLY, interval: 1 },
    14: { freq: RRule.WEEKLY, interval: 2 },
    28: { freq: RRule.WEEKLY, interval: 4 },
    30: { freq: RRule.MONTHLY, interval: 1 },
    60: { freq: RRule.MONTHLY, interval: 2 },
    90: { freq: RRule.MONTHLY, interval: 3 },
    180: { freq: RRule.MONTHLY, interval: 6 },
    360: { freq: RRule.YEARLY, interval: 1 },
};
export const getLastNOccurrences = (rule, limit = 200, fromDate = new Date()) => {
    const results = [];
    let cursor = fromDate;
    for (let i = 0; i < limit; i++) {
        cursor = rule.before(cursor);
        if (!cursor)
            break;
        results.push(cursor);
    }
    return results;
};
export const getNextOccurrence = (rule, fromDate = new Date()) => rule.after(fromDate);
export const getRRuleString = (rule) => rule
    .toString()
    .split('\n')
    .filter((line) => !line.startsWith('DTSTART'))
    .map((line) => line.replace(/^RRULE:/, ''))
    .join('\n');
export const rruleStringToFrequency = (rrule) => {
    try {
        const parsed = RRule.parseString(rrule);
        for (const [key, value] of Object.entries(RRULE_FREQUENCY)) {
            if (value.freq === parsed.freq && value.interval === parsed.interval) {
                return FREQUENCY[Number(key)];
            }
        }
        return null;
    }
    catch {
        return null;
    }
};
